import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MmDialogData } from '@metromarkets/components';
import { Store } from '@ngrx/store';

import { DocumentsGroup, GroupedDocumentItem, OrderLine } from '../../models';
import { ReceiveDocumentGetLink } from '../../store/receive-document-link';
import { OrdersHistoryState } from '../../store/orders-history-list';
import { DOCUMENT_CREATED_DATE_FORMAT } from '../../constants';


@Component({
  selector: 'app-download-invoices-dialog',
  templateUrl: './download-invoices-dialog.component.html',
  styleUrls: ['./download-invoices-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadInvoicesDialogComponent {
  public readonly displayedColumns = this.data
    .isCreditNotesVisible ? ['products', 'invoices', 'creditNotes'] : ['products', 'invoices'];
  public readonly dateFormat = DOCUMENT_CREATED_DATE_FORMAT;

  constructor(@Inject(MmDialogData) public data: {
                orderNumber: string,
                documents: DocumentsGroup[],
                isCreditNotesVisible: boolean,
              },
              private store$: Store<OrdersHistoryState>) {
  }

  public downloadFile(file: GroupedDocumentItem) {
    const { id, name, type } = file;

    this.store$.dispatch(new ReceiveDocumentGetLink({ id, name, type }));
  }

  public trackByProduct(index: number, orderLine: OrderLine): string {
    return orderLine.product.name;
  }

  public trackByDocument(index: string, documentArray: GroupedDocumentItem[]): string {
    const [document] = documentArray;

    return document.id;
  }
}
